import { useId } from "react";
import { Chave } from "../../components/ui.js";

/**
 * Salvar a foto sem IA (#95): o que vai ser publicado, e a única decisão que resta — se ela entra na galeria do
 * salão. Começa desligado: a foto sem IA é para imprimir, e a TV é a vitrine das peças.
 *
 * O botão de salvar fica na faixa de ações do painel, como em toda etapa.
 */
export function EtapaSalvarFoto({
  fotoUrl,
  naGaleria,
  aoMudarNaGaleria,
}: {
  fotoUrl: string;
  naGaleria: boolean;
  aoMudarNaGaleria: (v: boolean) => void;
}) {
  const idDaDica = useId();

  return (
    <div className="flex flex-col gap-4">
      <div className="overflow-hidden rounded-peca border border-borda bg-black">
        <img
          src={fotoUrl}
          alt="A foto que vai ser salva"
          className="max-h-[42dvh] w-full object-contain"
        />
      </div>

      <p className="text-[0.9375rem] leading-relaxed text-texto-suave">
        A foto é salva como foi tirada, sem IA, e fica pronta para imprimir, baixar e enviar.
      </p>

      <div className="flex flex-col gap-1">
        <Chave
          ligada={naGaleria}
          aoAlternar={aoMudarNaGaleria}
          rotulo="Mostrar na galeria do salão"
          texto="Mostrar na galeria do salão"
          descricaoId={idDaDica}
        />
        <p id={idDaDica} className="text-[0.8125rem] text-texto-fraco">
          Aparece nas TVs que mostram todas as vivências. Dá para mudar depois, na Biblioteca.
        </p>
      </div>
    </div>
  );
}
